<template>
  <div class="overlay" data-testid="font-overlay">
    <basic-overlay-style
      :bounding-box="boundingBox"
      :color="color"
      :border="false"
    />
    <i-tooltip
      v-if="tooltipText"
      :target="`#${containerId}`"
      :title="tooltipText"
      :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
    />
  </div>
</template>

<script>
import BasicOverlayStyles from './BasicOverlayStyles';
import { iTooltip, iTooltipAlignmentMode } from '@inscribe/signal';

export default {
  components: {
    'basic-overlay-style': BasicOverlayStyles,
    iTooltip,
  },
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    color: {
      type: [Array, String],
      required: true,
    },
    tooltipText: {
      type: String,
      default: undefined,
    },
    containerId: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      iTooltipAlignmentMode,
    };
  },
};
</script>
